import { io } from "socket.io-client";
import { WS_BASE_URL } from "../helper/env";
import { useEffect, useState } from "react";

// const x = io();
// /**
//  * The complete Triforce, or one or more components of the Triforce.
//     @type {typeof x}
//  */
// export var socketConnections = null;

export default function useSocket({
  headers = {},
  wsUrl = null,
  setConnectionsError = () => {},
}) {
  const [loading, setLoading] = useState(true);
  const [socketConnections, setSocket] = useState();

  useEffect(() => {
    var errorCounter = 0;
    if (!socketConnections) {
      const ws = io(wsUrl || WS_BASE_URL, {
        extraHeaders: headers,
      });
      setSocket(ws);
      return;
    }
    socketConnections.open()
    socketConnections.on("connect_error", function (error) {
      errorCounter++;
      if (errorCounter === 3) {
        socketConnections.close();
        setConnectionsError({
          type: "error",
          message: "خطا در برقراری ارتباط",
          code: 346279,
        });
        setLoading(false);
      }
    });

    return () => {
      errorCounter = 0;
      socketConnections.close();
    };
  }, [socketConnections]);

  return {
    socketConnections,
    closeSocket: () => {
      socketConnections.close();
    },
    openSocket: () => {
      socketConnections.open();
    },
    onSocket: (emit, callbackFn) => {
      socketConnections.on(emit, callbackFn);
    },
    emitSocket: (emit, obj) => {
      console.log("run emit");
      socketConnections.emit(emit, obj);
    },
    loading,
    setLoading,
  };
}
